import { writable } from 'svelte/store';

const sysData = writable({ });

export default sysData;